import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import cough from '../images/COVID-Icons_Cough.png'
import distancing from '../images/COVID-Icons_Distance.png'
import touchFace from '../images/COVID-Icons_Hand.png'
import washHands from '../images/COVID-Icons_Wash.png'
import test from '../images/ic-results.png'
import plus from '../images/plus28a845.png'

import { Card, CardDeck } from 'react-bootstrap'

import { setSelectedLabResult } from '../actions/api'
import UserDependentBanner from './userDependentBanner'

class ParentalAccessResultsBox extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }


    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {

    }

    handleMessage(event, l){
        this.props.dispatch(setSelectedLabResult(l));
    }

    //TODO
    renderUser(){

    }

    renderDependentButton() {
        return (
            <div className="row justify-content-center" style={{marginTop: 30}}>
                <Link className="addChildBttn" to="/register_dependent"><h5 className="center"><img src={plus} width="40"/> {this.props.strings.ADD_CHILD_BTTN}</h5></Link>
            </div>
        );
    }

    //TODO
    renderUserDependents=()=>{
        if(this.props.dependents === undefined || this.props.dependents===null) {
            return null;
        } else {
            let dependentsList = this.props.dependents.map((dependent, id) =>{
                return <UserDependentBanner key={id} index ={id} user={dependent} strings={this.props.strings}/>
            });
            return dependentsList;
        }
    }

    render() {
        if(this.props.user === null || this.props.user === undefined){
            return (<div></div>);
        }
        else{
            let dependents = this.renderUserDependents();
            console.log(this.props.dependents);
            return (
                <div className="col-12 col-lg-8 col-md-12 order-2 order-sm-2 order-md-1 ml-auto ml-md-auto">
                    <div className="row">
                        <div className="col-12">
                            <div className="testName">
                                <div class="testIcon"><img src={test} width="25" /></div>
                                <h4>{this.props.strings.PARENTAL_ACCESS_RESULT_BOX_HEADER}
                                </h4>
                            </div>
                            <div>
                                <UserDependentBanner user={this.props.user} results={this.props.results} strings={this.props.strings}/>
                            </div>
                        </div>
                    </div>
                    <div className="add-dependent-icon">
                        {this.renderDependentButton()}
                    </div>
                    <div className="dependents">
                        {dependents}
                    </div>
                    <div class="alert alert-info hideMobile" role="alert">
                        <CardDeck>
                            <Card>
                                <Card.Img variant="top" src={washHands} />
                                <Card.Body>
                                    <Card.Text>
                                        {this.props.strings.ICON_WASHHANDS}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Img variant="top" src={touchFace} />
                                <Card.Body>
                                    <Card.Text>
                                        {this.props.strings.ICON_TOUCHFACE}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Img variant="top" src={cough} />
                                <Card.Body>
                                    <Card.Text>
                                        {this.props.strings.ICON_COUGH}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Img variant="top" src={distancing} />
                                <Card.Body>
                                    <Card.Text>
                                        {this.props.strings.ICON_DISTANCING}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </CardDeck>

                        <p>{this.props.strings.INFO_CONTENT}<b>{this.props.strings.INFO_CONTENT_2}</b></p>
                        <h6>{this.props.strings.INFO_BOX_HEADER} <a href="https://www.gnb.ca/coronavirus">www.gnb.ca/coronavirus</a></h6>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
        user: state.api.user,
        dependents: state.api.dependents,
        dependentsResults: state.api.dependentResults,
    }
}

const ConnectedParentalAccessResultsBox = connect(
    mapStateToProps
)(ParentalAccessResultsBox);
export default ConnectedParentalAccessResultsBox;
